import {AxiosError} from 'axios';
import {
    axiosInterceptorsService,
    IAxiosInterceptorsService
} from '@techsee/techsee-client-infra/lib/services/AxiosInterceptorsService';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {RouteName} from '../../router/route-names';

const trace = getAppTracer('ReactAuthInterceptor');

export const setupReactAuthErrorInterceptor = (): void => {
    (axiosInterceptorsService as IAxiosInterceptorsService).setDefaultAuthErrorHandler(
        async (error: AxiosError): Promise<void> => {
            const response = error.response;
            if (response?.status !== 401) {
                return;
            }

            trace.info('401 received', {url: error.config?.url});

            const rootStore = getRootStore();

            // Skip if SSO auth flow is active — let handleUnknownRoute handle 400/401/403 recovery
            if (rootStore.authHandlerService.isInSsoAuthFlow) {
                trace.info('Skipping interceptor redirect — SSO auth flow in progress');
                return;
            }

            const authExpiry = rootStore.authExpiryService;
            const responseData = response.data as {expired?: boolean} | undefined;

            // Session expired modal: show modal instead of redirecting
            if ((authExpiry?.isNotificationEnabled && responseData?.expired) || authExpiry?.isloginModalVisible) {
                trace.info('Session expired modal triggered', {expired: responseData?.expired});
                authExpiry?.setSessionAsExpired();
                return;
            }

            // Redirect to login if not already on a login page
            const isOnLoginPage = window.location.pathname.startsWith('/login');
            if (!isOnLoginPage) {
                trace.info('Redirect to login');
                await rootStore.tsReactStateHelper.navigateTo(RouteName.LOGIN);
            }
        }
    );
};
